<template>
	<div class="home-background">
		<div class="home-title">
			<div class="title-left">
				<img style="width: 28px; height: 26px;" src="@/assets/images/login/title_icon.png" />
				<span>{{ today }}</span>
			</div>
			<div class="title-right">
				<div class="warn-wrap">
					<div class="warn-dot red"></div>
					<span>경고</span>
				</div>
				<div class="warn-wrap">
					<div class="warn-dot yellow"></div>
					<span>주의</span>
				</div>
			</div>
		</div>
		<div class="home-top">
			<div class="content-box">
				<div class="top-sub-title-red">
					<div>
						<span class="bold" sty>경고</span>
						<span style="margin-left: 10px; font-size: 16px;">
							Total <font class="bold">{{ topEmergencyList.length }}</font>
						</span>
					</div>
					<div class="top-count">
						<div 
							class="count-dot"
							v-if="topEmergencyList.length > 0"
							:class="this.slideLeftpx == 125 ? 'white' : ''"
						>
						</div>
						<div 
							class="count-dot"
							v-if="topEmergencyList.length > 3"
							:class="this.slideLeftpx == 125 - (246*3) ? 'white' : ''"
						>
						</div>
						<div 
							class="count-dot"
							v-if="topEmergencyList.length > 6"
							:class="this.slideLeftpx == 125 - (246*6) ? 'white' : ''"
						>
						</div>
					</div>
				</div>
				<div class="top-content" v-if="topEmergencyList.length > 0">
					<div class="button-zone" style="left: 0;">
						<button type="button" class="left-btn" @click.stop="slideLeft(1)"></button>
					</div>
					<div class="top-slide" :style="'left:'+ this.slideLeftpx +'px'">
						<template
							v-for="(patients) in topEmergencyList"
						>
							<div 
								:key="'emer_' + patients.id" 
								class="top-data"
								:class="newDataCheck(patients.recordDetailDate.substring(0, 20)) ? 'newdata' : ''"
							>
								<div class="data-zone">
									<div class="name-tag">시간</div>
									<span>{{todayCheck(patients.recordDetailDate)}}</span>
								</div>
								<div class="data-zone">
									<div class="name-tag">이름</div>
									<span>{{patients.name}}</span>
								</div>
								<div class="data-zone">
									<div class="name-tag">번호</div>
									<span>{{patients.id}}</span>
								</div>
								<div class="data-zone">
									<div class="name-tag">분류</div>
									<span class="font-red">{{ getDataTotal(patients) }}</span>
								</div>
							</div>
							<div :key="'emer_dot_' + patients.id" class="dot-line"></div>
						</template>
					</div>
					<div class="button-zone" style="right: 0;">
						<button type="button" class="right-btn" @click.stop="slideRight(1)"></button>
					</div>
				</div>
				<div v-if="topEmergencyList.length == 0" class="none-content">
					현재 경고 상태인 산모가 없습니다.
				</div>
			</div>
			<div class="content-box">
				<div class="top-sub-title-green">
					<div>
						<span class="bold" sty>조치중</span>
						<span style="margin-left: 10px; font-size: 16px;">
							Total <font class="bold">{{ actionList.length }}</font>
						</span>
					</div>
					<div class="top-count">
						<div 
							class="count-dot"
							v-if="actionList.length > 0"
							:class="this.slideLeftpx2 == 125 ? 'white' : ''"
						>
						</div>
						<div 
							class="count-dot"
							v-if="actionList.length > 3"
							:class="this.slideLeftpx2 == 125 - (246*3) ? 'white' : ''"
						>
						</div>
						<div 
							class="count-dot"
							v-if="actionList.length > 6"
							:class="this.slideLeftpx2 == 125 - (246*6) ? 'white' : ''"
						>
						</div>
					</div>
				</div>
				<div class="top-content" v-if="actionList.length > 0">
					<div class="button-zone" style="left: 0;">
						<button type="button" class="left-btn" @click.stop="slideLeft(2)"></button>
					</div>
					<div class="top-slide" :style="'left:'+ this.slideLeftpx2 +'px'">
						<template
							v-for="(patients) in actionList"
						>
							<div 
								:key="'action_' + patients.id" 
								class="top-data"
							>
								<div class="data-zone">
									<div class="name-tag">시간</div>
									<span>{{todayCheck(patients.recordDetailDate)}}</span>
								</div>
								<div class="data-zone">
									<div class="name-tag">이름</div>
									<span>{{patients.name}}</span>
								</div>
								<div class="data-zone">
									<div class="name-tag">번호</div>
									<span>{{patients.id}}</span>
								</div>
								<div class="data-zone">
									<div class="name-tag">분류</div>
									<span class="font-red">{{getDataTotal(patients)}}</span>
								</div>
							</div>
							<div :key="'action_dot_' + patients.id" class="dot-line"></div>
						</template>
					</div>
					<div class="button-zone" style="right: 0;">
						<button type="button" class="right-btn" @click.stop="slideRight(2)"></button>
					</div>
				</div>
				<div v-if="actionList.length == 0" class="none-content">
					현재 조치중인 산모가 없습니다.
				</div>
			</div>
		</div>
		<div class="home-bottom">
			<div class="content-box">
				<div class="table-name">
					<span>경고 데이터</span>
					<button type="button" class="table-btn" :class="this.searchText == 1 ? 'btn-on' : ''" @click.stop="dataChange(1);">전체</button>
					<button type="button" class="table-btn" :class="this.searchText == 2 ? 'btn-on' : ''" @click.stop="dataChange(2);">경고</button>
					<button type="button" class="table-btn" :class="this.searchText == 3 ? 'btn-on' : ''" @click.stop="dataChange(3);">주의</button>
				</div>
				<div class="home-scroll-div scroll">
					<table class="tb-list-vertical" style="table-layout: fixed;">
						<colgroup>
							<col width="12%">
							<col width="16%">
							<col width="16%">
							<col width="23%">
							<col width="23%">
							<col width="10%">
						</colgroup>
						<thead>
							<th>상태</th>
							<th>참여자 번호</th>
							<th>이름</th>
							<th>데이터 분류</th>
							<th>수신 일시</th>
							<th></th>
						</thead>
						<tbody>
							<template
								v-for="(patients) in allDataList"
							>
								<tr
									:key="patients.id + '0'"
									@click.stop="openSign(patients)"
									:class="openList.indexOf(patients.id) >= 0 ? 'openTr' : ''"
								>
									<td><div class="status" :class="statusColor(patients.status)">{{getStatusType(patients.status)}}</div></td>
									<td>{{patients.id}}</td>
									<td>{{patients.name}}</td>
									<td>{{getDataTotal(patients)}}</td>
									<td>{{todayCheck(patients.updateDate)}}</td>
									<td @click.stop="openPage(patients)"><img :style="openList.indexOf(patients.id) >= 0 ? 'transform: rotate(180deg);' : ''" style="width: 11.9px; height: 7px;" src="@/assets/images/home/table_arrow.png" /></td>
								</tr>
								<tr
									:key="patients.id + 'sub'"
									v-if="openList.indexOf(patients.id) >= 0 && patients.dataList.length > 0"
								>
									<td colspan="6">
										<table class="tb-list-vertical sub-table" style="table-layout: fixed;">
											<colgroup>
												<col width="12%">
												<col width="16%">
												<col width="16%">
												<col width="23%">
												<col width="23%">
											</colgroup>
											<thead>
												<th>상태</th>
												<th>데이터 분류</th>
												<th>수치</th>
												<th>측정 일시</th>
												<th>수신 일시</th>
											</thead>
											<tbody>
												<template
													v-for="(data, dataIndex) in patients.dataList"
												>
													<tr
														:key="dataIndex"	
													>
														<td><div class="status" :class="statusColor(data.status)">{{getStatusType(data.status)}}</div></td>
														<td>{{ getRecordType(data.recordType) }}</td>
														<td v-if="data.recordType != 'PROTEINURIA'">{{data.recordType == 'SLEEP_TIME' ? getSleepTime(data.value) : data.recordType == 'BLOOD_PRESSURE' ? data.value + '/' + data.subValue : data.value}}</td>
														<td v-if="data.recordType == 'PROTEINURIA'">
															<span v-if="data.value == 1">0 mg/L</span>
															<span v-if="data.value == 2">15-30 mg/L</span>
															<span v-if="data.value == 3">30 mg/L</span>
															<span v-if="data.value == 4">100 mg/L</span>
															<span v-if="data.value == 5">300 mg/L</span>
															<span v-if="data.value == 6">1000 mg/L 이상</span>
														</td>
														<td>{{todayCheck(data.recordDetailDate)}}</td>
														<td>{{todayCheck(data.updateDate)}}</td>
													</tr>
												</template>
											</tbody>
										</table>
									</td>
								</tr>
							</template>
							<tr v-if="allDataList.length == 0">
								<td colspan="6" class="no-list">
									데이터가 존재하지 않습니다.
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="content-box">
				<div class="table-name">
					<span>조치 중 데이터</span>
				</div>
				<div class="home-scroll-div scroll">

					<table class="tb-list-vertical" style="table-layout: fixed;">
						<colgroup>
							<col width="12%">
							<col width="16%">
							<col width="16%">
							<col width="23%">
							<col width="23%">
						</colgroup>
						<thead>
							<th>상태</th>
							<th>참여자 번호</th>
							<th>이름</th>
							<th>데이터 분류</th>
							<th>담당자</th>
						</thead>
						<tbody>
							<template
								v-for="(patients) in actionList"
							>
								<tr
									:key="patients.id + '1'"
									@click.stop="openData(patients)"
								>
									<td><div class="status" :class="statusColor(patients.status)">{{getStatusType(patients.status)}}</div></td>
									<td>{{patients.id}}</td>
									<td>{{patients.name}}</td>
									<td>{{ getDataTotal(patients) }}</td>
									<td>{{patients.managerName}}</td>
								</tr>
							</template>
							<tr v-if="actionList.length == 0">
								<td colspan="5" class="no-list">
									데이터가 존재하지 않습니다.
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="content-box">
				<div class="table-name">
					<span>조치 완료 데이터</span>
				</div>
				<div class="home-scroll-div scroll">

					<table class="tb-list-vertical" style="table-layout: fixed;">
						<colgroup>
							<col width="12%">
							<col width="16%">
							<col width="16%">
							<col width="23%">
							<col width="23%">
						</colgroup>
						<thead>
							<th>상태</th>
							<th>참여자 번호</th>
							<th>이름</th>
							<th>데이터 분류</th>
							<th>완료 일시</th>
						</thead>
						<tbody>
							<template
								v-for="(patients) in endList"
							>
								<tr
									:key="patients.id + '2'"
								>
									<td><div class="status" :class="statusColor(patients.status)">{{getStatusType(patients.status)}}</div></td>
									<td>{{patients.id}}</td>
									<td>{{patients.name}}</td>
									<td>{{getDataTotal(patients)}}</td>
									<td>{{todayCheck(patients.completeDate)}}</td>
								</tr>
							</template>
							<tr v-if="endList.length == 0">
								<td colspan="5" class="no-list">
									데이터가 존재하지 않습니다.
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<EmergencyAlarm v-if="isDataPopup" :topEmergencyList="topEmergencyList"/>
		<EmergencySign v-if="isSignPopup" :collectData="collectData"/>
		<CollectDataPopup v-if="isCollectDataPopup" :collectData="collectData"/>
	</div>
</template>

<script>
import Vue from "vue";
import VeeValidator from "vee-validate";
import axios from "axios";
import EmergencyAlarm from "@/components/home/EmergencyAlarm.vue";
import EmergencySign from "@/components/home/EmergencySign.vue";
import CollectDataPopup from "@/components/collectData/CollectDataPopup.vue";
Vue.use(VeeValidator);

export default {
	name: "Home",
	created() {
		this.logger.debug(this, ".created()");
		this.selectEmergencyList();
		this.selectActionList();
		this.selectEndList();
		this.setRecordStatus();
	},
	mounted() {
		this.logger.debug(this, ".mounted()");
		this.nowDate();
		setInterval(this.selectEmergencyList, 30000);
		setInterval(this.selectActionList, 30000);
		setInterval(this.selectEndList, 30000);
		setInterval(this.setRecordStatus, 300000);
	},
	data() {
		return {
			userId: "",
			password: "",
			loginResult: false,
			findId: "N",
			findPass: "N",
			isMode: 1,
			today: "",
			slideLeftpx: 125,
			slideLeftpx2: 125,
			pagination: {},
			emergencyList: [],
			actionList: [],
			endList: [],
			isDataPopup: false,
			isCollectDataPopup: false,
			isSignPopup: false,
			openList: [],
			searchText: "1",
			collectData: {},
			topEmergencyList: [],
			cautionList: [],
			allDataList: [],
		};
	},
	components: {
		EmergencyAlarm,
		EmergencySign,
		CollectDataPopup,
	},
	methods: {
		selectMode(code){
			if(code == 1){ this.isMode = 1;}
			else{this.isMode = 2;}
		},
		setRecordStatus(){
			this.logger.debug(this, "setRecordStatus()");
			axios
				.post(this.config.contextRoot + "/home/setRecordStatus.do", {searchText: this.searchText})
				.then((response) => {
					console.log(response);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectEmergencyList(){
			if(this.$route.path == '/home'){
				this.logger.debug(this, "selectEmergencyList()");
				axios
					.post(this.config.contextRoot + "/home/selectEmergencyList.do", {searchText: this.searchText})
					.then((response) => {
						console.log(response);
						this.emergencyList = response.data.emergencyList;
						this.allDataList = response.data.emergencyList;
						
						this.topEmergencyList = [];
						this.cautionList = [];
	
						for(var i = 0; i < this.emergencyList.length; i++){
							if(this.emergencyList[i].status == 'EMERGENCY'){
								this.topEmergencyList.push(this.emergencyList[i]);
							}
							if(this.emergencyList[i].status == 'CAUTION'){
								this.cautionList.push(this.emergencyList[i]);
							}
						}
	
						this.dataChange(this.searchText);
						// if(this.topEmergencyList.length > 0){
						// 	this.isDataPopup = true;
						// }
						// this.$nextTick(function () {
						// 	setTimeout(function() {
						// 		// 로딩바 닫기 요청
						// 		EventBus.$emit("project-loading", false);
						// 	}.bind(this), 400);
						// });
					})
					.catch((error) => {
						this.exceptionHandler(this, error);
					});
			}
		},
		selectActionList(){
			if(this.$route.path == '/home'){
				this.logger.debug(this, "selectActionList()");
				this.openProjectIndex = -1;
				axios
					.post(this.config.contextRoot + "/home/selectActionList.do", {searchText: this.searchText})
					.then((response) => {
						console.log(response);
						this.actionList = response.data.actionList;
						// this.$nextTick(function () {
						// 	setTimeout(function() {
						// 		// 로딩바 닫기 요청
						// 		EventBus.$emit("project-loading", false);
						// 	}.bind(this), 400);
						// });
					})
					.catch((error) => {
						this.exceptionHandler(this, error);
					});
			}
		},
		selectEndList(){
			if(this.$route.path == '/home'){
				this.logger.debug(this, "selectEndList()");
				this.openProjectIndex = -1;
				axios
					.post(this.config.contextRoot + "/home/selectEndList.do", {searchText: this.searchText})
					.then((response) => {
						console.log(response);
						this.endList = response.data.endList;
						// this.$nextTick(function () {
						// 	setTimeout(function() {
						// 		// 로딩바 닫기 요청
						// 		EventBus.$emit("project-loading", false);
						// 	}.bind(this), 400);
						// });
					})
					.catch((error) => {
						this.exceptionHandler(this, error);
					});
			}
		},
		nowDate(){
			const date = new Date();
			const year = date.getFullYear(); // YYYY
			const month = date.getMonth() + 1; // MM
			const day = date.getDate();	// DD
			const hours = date.getHours(); // HH
			const minutes = date.getMinutes(); // MM
			const seconds = date.getSeconds(); // ss
			const week = ['일', '월', '화', '수', '목', '금', '토'];
			setTimeout(function() {
                this.nowDate()
            }.bind(this), 1000);

			this.today = year + '-' + month.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0') + ' (' + week[date.getDay()] + ') ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
		},
		slideLeft(num){
			// size가 4개부터일때만
			if(num == 1){
				if(Math.abs(this.slideLeftpx) != 125){
					this.slideLeftpx += 246*3;
				}
			}
			if(num == 2){
				if(Math.abs(this.slideLeftpx2) != 125){
					this.slideLeftpx2 += 246*3;
				}
			}
		},
		slideRight(num){
			// size가 4개부터일때만
			var length = 0;
			if(num == 1){
				if(this.topEmergencyList.length > 0){
					length = 0;
				}
				if(this.topEmergencyList.length > 3){
					length = 3;
				}
				if(this.topEmergencyList.length > 6){
					length = 6;
				}
				if(Math.abs(this.slideLeftpx) != Math.abs(246*length - 125)){
					this.slideLeftpx -= 246*3;
				}
			}
			if(num == 2){
				if(this.actionList.length > 0){
					length = 0;
				}
				if(this.actionList.length > 3){
					length = 3;
				}
				if(this.actionList.length > 6){
					length = 6;
				}
				if(Math.abs(this.slideLeftpx2) != Math.abs(246*length - 125)){
					this.slideLeftpx2 -= 246*3;
				}
			}
		},
		openPage(patients) {
			this.logger.debug(this, "openPage()");
			
			if(patients.dataList.length < 1){
				axios
						.post(this.config.contextRoot + "/home/selectData.do", patients)
						.then((response) => {
							console.log(response);
	
							patients.dataList = response.data.dataList;
							patients.managerList = response.data.managerList;

						})
						.catch((error) => {
							this.exceptionHandler(this, error);
						});
			}

			let id = patients.id;
			let index = this.openList.indexOf(id);

			if(index >= 0) this.openList.splice(index, 1);
			else this.openList.push(id);
		},
		openSign(patients) {
			this.logger.debug(this, "openSign()");

			if(patients.dataList.length < 1){
				axios
						.post(this.config.contextRoot + "/home/selectData.do", patients)
						.then((response) => {
							console.log(response);
	
							patients.dataList = response.data.dataList;
							patients.managerList = response.data.managerList;
							this.collectData = patients;
							this.isSignPopup = true;
						})
						.catch((error) => {
							this.exceptionHandler(this, error);
						});
			}
			else{
				this.collectData = patients;
				this.isSignPopup = true;
			}

		},
		openData(patients) {
			this.logger.debug(this, "openData()");

			if(patients.dataList.length < 1){
				axios
						.post(this.config.contextRoot + "/home/selectData.do", patients)
						.then((response) => {
							console.log(response);
	
							patients.dataList = response.data.dataList;
							patients.managerList = response.data.managerList;
							this.collectData = patients;
							this.isCollectDataPopup = true;
						})
						.catch((error) => {
							this.exceptionHandler(this, error);
						});
			}
			
		},
		dataChange(code){
			this.searchText = code;
			if(code == 1){
				this.allDataList = this.emergencyList;
			}
			else if(code == 2){
				this.allDataList = this.topEmergencyList;
			}
			else if(code == 3){
				this.allDataList = this.cautionList;
			}
		},
		newDataCheck(recordDate){
			const rDate = new Date(recordDate);
			const nowDate = new Date();
			const resultDate = nowDate.getTime() - rDate.getTime();
			const resultMin = resultDate / (60*1000)
			if(resultMin < 10){
				return true;
			}
			else{
				return false;
			}
		},
		todayCheck(recordDate){
			const rDate = recordDate.substring(0, 11);
			if(rDate == this.today.substring(0, 11)){
				return "오늘 " + recordDate.substring(11, 19)
			}
			else{
				return recordDate.substring(0, 11)
			}
		},
		getRecordType(recordType){
			var result = "";

			if(recordType == 'WEIGHT'){
				result = '체중'
			}
			if(recordType == 'BLOOD_PRESSURE'){
				result = '혈압'
			}
			if(recordType == 'BLOOD_GLUCOSE'){
				result = '혈당'
			}
			if(recordType == 'HEART_RATE'){
				result = '심박수'
			}
			if(recordType == 'STEP_COUNT'){
				result = '걸음수'
			}
			if(recordType == 'CALORIE'){
				result = '칼로리'
			}
			if(recordType == 'PROTEINURIA'){
				result = '단백뇨'
			}
			if(recordType == 'OXYGEN_SATURATION'){
				result = '산소포화도'
			}
			if(recordType == 'STRESS'){
				result = '스트레스'
			}
			if(recordType == 'SLEEP_TIME'){
				result = '수면시간'
			}

			return result;
		},
		getStatusType(status){
			var result = "정상";
			if(status == 'EMERGENCY'){
				result = '경고'
			}
			if(status == 'CAUTION'){
				result = '주의'
			}
			return result;
		},
		getDataTotal(patients){
			var result = "";

			if(patients.insertCnt == 0){
				result = '0건';
			}
			else{
				result = '총 ' + (patients.insertCnt) + '건';
			}
			return result;
		},
		statusColor(status){
			var result = "green";
			if(status == 'EMERGENCY'){
				result = 'red'
			}
			if(status == 'CAUTION'){
				result = 'yellow'
			}
			return result;
		},
		getSleepTime(ms){
			var hour = String(Math.floor((ms / (1000*60*60)) % 24)).padStart(2, "0");
			var min = String(Math.floor((ms / (1000*60)) % 60)).padStart(2, "0");
			var sec = String(Math.floor((ms / (1000)) % 60)).padStart(2, "0");
			return hour+':'+min+':'+sec;
		}
	},
};
</script>
<style>
@import '../../assets/css/login/login.css';
.home-background{
	width: 100%;
	height: 100%;
}
.home-title{
	width: 100%;
	height: 29px;
	display: flex;
    justify-content: space-between;
}
.title-left{
	display: flex;
    align-items: center;
    column-gap: 12px;
	font-size: 24px;
	font-weight: bold;
}
.title-right{
	display: flex;
    align-items: center;
	font-size: 14px;
	column-gap: 20px;
}
.warn-dot{
	width: 16px;
	height: 16px;
	border-radius: 50px;
}
.font-red{
	color: #F94848;
}
.red{
	background-color: #F94848;
}
.yellow{
	background-color: #FFAD09;
}
.warn-wrap{
	display: flex;
	align-items: center;
    column-gap: 4px;
}
.home-top{
	width: 100%;
	height: 180px;
	display: flex;
	column-gap: 20px;
	margin: 20px 0;
}
.home-bottom{
	width: 100%;
	height: calc(100% - 269px);
	display: flex;
	column-gap: 20px;
	margin: 20px 0;
}
.content-box{
	width: 100%;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 0 10px 0px #ccc;
	background-color: #fff;
	position: relative;
}
.top-sub-title-red{
	width: 100%;
	height: 52px;
	background-color: #F94848;
	display: flex;
    align-items: center;
	justify-content: space-between;
    padding-left: 32px;
    color: #FFF;
	font-size: 20px;
}
.top-sub-title-green{
	width: 100%;
	height: 52px;
	background-color: #4BD985;
	display: flex;
    align-items: center;
	justify-content: space-between;
    padding-left: 32px;
    color: #FFF;
	font-size: 20px;
}
.count-dot{
	width: 8px;
	height: 8px;
	border: 1px solid #fff;
	border-radius: 50px;
}
.top-count{
	display: flex;
    column-gap: 5px;
	margin-right: 32px;
}
.white{
	background-color: #fff;
}
.none-content{
	width: 100%;
    height: calc(100% - 52px);
    display: flex;
    justify-content: center;
    align-items: center;
	font-size: 18px;
	color: #A9A9A9;
}
.left-btn{
	width: 31px;
	height: 38px;
	background-image: url(../../assets/images/home/left_btn.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: 31px 38px;
}
.right-btn{
	width: 31px;
	height: 38px;
	background-image: url(../../assets/images/home/right_btn.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: 31px 38px;
}
.name-tag{
	width: 44px;
	height: 22px;
	background-color: #EFEFEF;
	border-radius: 11px;
	font-size: 14px;
	color: #A9A9A9;
	display: flex;
    justify-content: center;
    align-items: center;
}
.data-zone{
	display: flex;
    justify-content: flex-start;
	align-items: center;
	column-gap: 10px;
	font-size: 16px;
	font-weight: bold;
}
.top-slide{
	display: flex;
	align-items: center;
	column-gap: 32px;
	height: 100%;
	position: absolute;
	transition: all 0.2s ease;
}
.top-content{
	display: flex;
	width: 100%;
    height: calc(100% - 52px);
    align-items: center;
    justify-content: center;
	/* column-gap: 73px; */
	overflow: hidden;
	position: relative;
}
.dot-line{
	height: 64px;
	border: 1px solid #DDDDDD;
	border-style: dashed;
}
.top-data{
	display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 4px;
	padding: 5px;
    width: 180px;
	border: 2px solid rgb(0, 0, 0, 0);
}
.table-name{
	font-size: 20px;
	font-weight: bold;
	width: 100%;
	height: 60px;
	display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: 10px;
    padding-left: 32px;
	position: absolute;
	top: 0;
}
.table-btn{
	width: 66px;
	height: 29px;
	border-radius: 15px;
	font-size: 16px;
	font-weight: 600;
	color: #6D6D6D;
}
.table-btn:hover{
	color: #FFF;
	background-color: #555555;
}
.btn-on{
	color: #FFF;
	background-color: #555555;
}
.button-zone{
	width: 100px;
	height: 100%;
	display: flex;
    justify-content: center;
    align-items: center;
	position: absolute;
	background-color: #fff;
    z-index: 1;
}
.newdata{
	border: 2px solid #F94848;
    border-radius: 10px;
}
.sub-table{
	box-shadow: 0 0 10px 0px #ccc;
	opacity: 0.9;
}
.sub-table th{
	font-size: 15px;
	height: 31px;
	border: 1px solid #ddd;
	border-top: 1px solid #191C26;
	background-color: #F8F9FB;
}
.sub-table th:first-child{
	border-left: none;
}
.sub-table th:last-child{
	border-right: none;
}
.sub-table td{
	font-size: 14px;
	height: 31px;
	border: 1px solid #ddd;
	border-bottom: none;
}
.sub-table td:first-child{
	border-left: none;
}
.sub-table td:last-child{
	border-right: none;
}
.openTr > td {
	background-color: #EBF4FF;
}
.home-scroll-div{
	position: absolute;
	top: 60px;
	width: 100%;
	height: calc(100% - 60px);
	overflow: auto;
}
</style>

